import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center ms-1 ms-lg-3"
}
const _hoisted_3 = { class: "svg-icon svg-icon-1" }
const _hoisted_4 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_5 = {
  class: "btn btn-icon btn-active-light-primary cursor-pointer symbol symbol-30px symbol-md-40px pulse",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.checkRoleSettings)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_tooltip, {
            placement: "bottom-start",
            effect: "light",
            content: "Тохиргоо"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "btn btn-icon btn-active-light-primary position-relative w-30px h-30px w-md-40px h-md-40px",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToSettings && _ctx.goToSettings(...args)))
              }, [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Interface/Settings-02.svg" })
                ])
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Interface/User.svg" })
        ]),
        _hoisted_7
      ]),
      _createVNode(_component_KTUserMenu)
    ])
  ]))
}